<template>
    <div>
        <base-crud
                crudName="Jornada de Trabalho"
                newText="Nova Jornada"
                :table="WorktimeTable"
                :columns="columns"
                :options="options"
                :endPoint='endPoint'
                :enableAdd="true"
                :enableEdit="true"
                :enableDelete="true"
                :enableView="false"
                :dataForm="dataForm"
        >
        </base-crud>
    </div>
</template>

<script>
    import BaseCrud from '../Base/BaseCrud'

    export default {
        data: function () {
            return {
                WorktimeTable: 'WorktimeTable',
                Worktimes: [],
                pages: [],
                url: '',
                columns: ['id', 'title', 'started_at', 'ended_at', 'default', 'actions'],
                tableData: [],
                options: {
                    filterByColumn: true,
                    filterable: ['id', 'title', 'started_at', 'ended_at', 'default'],
                    sortable: ['id', 'title', 'started_at', 'ended_at', 'default'],
                    pagination: {chunk: 10, dropdown: false, nav: 'scroll' },
                    perPage: 10,
                    perPageValues: [10,25,50,100],
                    headings: {
                        'id': 'ID',                        
                        'name' : 'Nome',
                        'started_at': 'Inicia em', 
                        'ended_at': 'Termina em', 
                        'default': 'Padrão',
                        'actions' : 'Ações'
                    },
                    requestFunction: function (data) {
                        let requestData = {};

                        let query = this.$parent.$parent.query(data.query);
                        requestData.params = data;
                        requestData.params.query = '';
                        requestData.params.with = [];

                        return this.$http
                            .get(this.url + '?' + query, requestData)
                            .catch(function (e) {
                                    this.dispatch("error", e);
                                }.bind(this)
                            );
                    },
                    templates: {
                        started_at: function (h, row, index) {
                            return new Date(row.started_at).toLocaleDateString();
                        },
                        ended_at: function (h, row, index) {
                            return new Date(row.ended_at).toLocaleDateString()
                        },
                        default: function (h, row, index) {
                            return row.default == '1' ? 'Sim' : 'Não'
                        }
                    },
                },
                endPoint: 'worktimes/',

                dataForm: {
                    id: {
                        type: "integer"
                    }
                }
            }
        },
        components: {
            BaseCrud
        },
        methods: {
          query: function (query) {
                let columns = {
                    id: 'id',
                    title: 'title',
                    email: 'email'
                };
                let filters = '';
                $.each(query, function (index, value) {
                    filters += columns[index] + '=' + value + '&';
                });

                return filters;
          }
        }
    }
</script>

<style scoped>
    .VuePagination {
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// src/components/Worktime/Crud.vue